export const SNACKBAR_NOTIFICATION_KEYS = {
  USED_RESET_TOKEN: "used_reset_token"
};
